// Copyright (c) 2026 Query Health Inc. All rights reserved.
// Author: Anmol Rajpal <anmol@quantinohealth.com>
// Licensed under a Commercial License. See LICENSE for terms.

import { useNavigate } from 'react-router-dom'
import OnboardOrgWizard from '@/components/OnboardOrgWizard'

export default function OnboardOrgPage() {
  const navigate = useNavigate()

  return <OnboardOrgWizard onDone={() => navigate('/orgs')} />
}
